"use client";
import React from "react";
import { useSearchParams } from "next/navigation";

import JobsListingLoader from "./Loading/JobsListingLoader";

import { Skeleton } from "@components/ui/skeleton";
import { classNames } from "@lib/helpers";

const Loading = () => {
  const searchParams = useSearchParams();
  const search = searchParams.get("search");

  const filters = new Array(10).fill(null);

  return (
    <div className="min-h-screen py-8 lg:py-[52px]">
      <div className="lg-container">
        <div className="flex">
          {!!search ? (
            <aside className="min-w-64 xl:min-w-[344px] pt-[72px] 1lg:pt-[88px] mr-10 hidden lg:flex">
              <div className="w-full">
                <header className="w-full h-[72px] lg:h-[60px] rounded-t-[12px] border-[#E7E7E7] px-5 border-b-4 lg:border-b border-0 lg:border lg:mb-5 flex items-center justify-between pr-16 lg:pr-5">
                  <Skeleton className="font-semibold text-[#1F2223] text-base text-transparent">
                    All Filters
                  </Skeleton>

                  <Skeleton className="rounded-lg h-9 w-[79px]" />
                </header>
                <div className="py-5 px-5 border-0 lg:border border-[#E7E7E7] divide-y divide-[#E7E7E7]">
                  {filters.map((_, index) => (
                    <div
                      key={index}
                      className={classNames(
                        "flex justify-between items-center",
                        index ? "mt-5 pt-5" : ""
                      )}
                    >
                      <Skeleton className="text-sm lg:text-[15px] font-medium text-[#1F2223] text-transparent">
                        Job Filter
                      </Skeleton>
                      <Skeleton className="w-5 h-5" />
                    </div>
                  ))}
                </div>
              </div>
            </aside>
          ) : null}
          <div className="flex flex-col gap-5 lg:gap-6 md:gap-10 flex-1">
            <div className="flex gap-4">
              <div className="flex-1">
                <Skeleton className="h-12 rounded-[8px]" />
              </div>
              {!!search ? (
                <Skeleton className="w-12 h-12 rounded-[8px] lg:hidden" />
              ) : null}
            </div>
            <JobsListingLoader search={search} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
